module.exports = __webpack_public_path__ + "static/media/2048.04f0257c.png";